export default class Vibes{
    constructor(element){
        this.element = document.querySelector(element);
        if(!this.element) return;
        this.videoFrame = this.element.querySelector(`${element}__video-modal`);
        this.btn = this.element.querySelector(`${element}__video-button`);

        this.bindEvents()

    }
    bindEvents(){
        this.btn.addEventListener('click', (e)=>{this.playVideo(e)})
    }

    playVideo(){
        this.videoFrame.classList.add('vibes__video-modal--active');
        this.videoFrame.src = this.videoFrame.src + '?autoplay=1&enablejsapi=1';
    }
}